<template>
    <div class="biz-new-policy">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <div class="biz-new-policy-head">
            <span class="title">{{mainTitle}}</span>
            <span class="view-default">
                <!-- <router-link :to="{ name: 'bizDefaultPolicy'}" target="_blank">
                    <img src="@/assets/img/icon/view_gray.svg" alt="">
                    預設條款
                </router-link> -->
            </span>
        </div>
        <div class="biz-new-policy-body" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
            <div class="wrap">
                <div class="item-list" :class="{'none-borde': policyList[index].state}" v-for="(policy, index) in policyList" :key="index">
                    <div v-if="policyList[index].state" class="edit-item" >
                        <div class="group">
                            <button class="save" @click="savePolicy(policy.policySettingCid, policyList[index].policySettingContent, index)">儲存</button>
                            <img class="delete" src="@/assets/img/icon/trash_gray.svg" @click="deletePolicy(policy.policySettingCid), policyList.splice(index, 1)" alt="">
                        </div>
                        <textarea v-model="policyList[index].policySettingContent" placeholder="輸入條款內容"></textarea>
                    </div>
                    <div v-else class="view">
                        <div class="group">
                            <img class="edit" src="@/assets/img/icon/edit_gray_light.svg" @click="policyList[index].state = true,newPolicy = false, newPolicyContent = null" alt="">
                            <img class="delete" src="@/assets/img/icon/trash_gray.svg" @click="deletePolicy(policy.policySettingCid), policyList.splice(index, 1)" alt="">
                        </div>
                        {{policy.policySettingContent}}
                    </div>
                </div>
                <div v-if="newPolicy && policyList.length < 9" >
                    <div class="edit-item">
                        <div class="group">
                            <button class="save" @click="savePolicy()">儲存</button>
                            <img class="delete" src="@/assets/img/icon/trash_gray.svg" @click="newPolicy = false, newPolicyContent = null" alt="">
                        </div>
                        <textarea v-model="newPolicyContent" placeholder="請輸入條款內容，上限1000字"></textarea>
                    </div>
                </div>
                <div v-if="policyList.length < 9" @click="newPolicy = true">
                    <div class="new-item">
                        <img src="@/assets/img/icon/plus_gray.svg" alt="">
                        新增條款 ( 最多 9 項條款 )
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { 
    apiBizGetLanlordPolicy,
    apiBizInsertLandlordPolicy,
    apiBizEditLandlordPolicy,
    apiBizDeleteLandlordPolicy
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            // mainTitle: this.mainTitle,
            modalHeight: this.resize?(window.innerHeight-300) + 'px':'unset',
            componentKey: 0,
            policyList: [],
            despositPolicyList: [],
            newPolicy: false,
            newPolicyContent: null,
            error: {
                policy: null
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            }
        }
    },
    props:{
        mainTitle: String,
        type: Number,
        resize: Boolean
    },
    mounted (){
        this.getPolicy()
        if(this.resize){
            window.addEventListener('resize', this.resizeModal)
        }
    },
    destroyed() {
        if(this.resize){
            window.removeEventListener('resize', this.resizeModal)
        }
    },
    watch: {
        newPolicyContent: function (val) {
            if( val.length > 1000){
                this.alart.fail = true
                this.msg.error = '字數限制1000以內'
                this.error.policy = '字數限制1000以內'
            }else{
                this.alart.fail = false
                this.msg.error = null
                this.error.policy = null
            }
        },
        policyList: {
            handler: function (val) {
                this.alart.fail = false
                this.msg.error = null
                this.error.policy = null
            },
            deep: true
        }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        getPolicy: function () {
            apiBizGetLanlordPolicy()
            .then(res =>{
                // console.log(res)
                if(res.data.status = 'SUCCESS'){
                    let housePolicy = null
                    if( this.type == 1){
                        housePolicy = res.data.result.landlordHousePolicyDto.policySettingDtoList

                        housePolicy.map((policy) => {
                            policy.state = false
                        })
                    }else if(this.type == 2){
                        housePolicy = res.data.result.landlordDepositPolicyDto.policySettingDtoList

                        housePolicy.map((policy) => {
                            policy.state = false
                        })
                    }
                    
                    this.policyList = housePolicy
                }else{
                    console.log('Policy err')
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        savePolicy: function (cid, content, index) {
            this.$analytics.logEvent('送出新增及編輯政策', { screen_name: '送出新增及編輯政策'})
            if(this.error.policy == null){
                if(cid){
                    let data = {
                        "policySettingContent": content,
                        "policySettingCid": cid
                    }

                    apiBizEditLandlordPolicy(data)
                    .then( res => {
                        console.log(res)
                        if(res.data.status == "SUCCESS"){
                            this.alart.success = true
                            this.msg.success = '儲存成功'
                            this.policyList[index].state = false
                            this.getPolicy()
                        }else{
                            this.alart.fail = true
                            if(res.data.errorCode == 999998){
                                this.msg.error = '字數限制1000以內'
                            }else{
                                this.msg.error = res.data.errorMsg 
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }else{
                    if(this.newPolicyContent){
                        let data = {
                            "policySettingContent": this.newPolicyContent,
                            "policySettingType": this.type
                        }

                        apiBizInsertLandlordPolicy(data)
                        .then( res => {
                            // console.log(res)
                            if(res.data.status == "SUCCESS"){
                                this.policyList.push({
                                    policySettingContent: this.newPolicyContent,
                                    state: false
                                })
                                this.newPolicyContent = null
                                this.alart.success = true
                                this.msg.success = '儲存成功'
                                this.getPolicy()
                            }else{
                                this.alart.fail = true
                                this.msg.error = res.data.errorMsg 
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                    }
                }
            }else{
                this.alart.fail = true
                this.msg.error = '字數限制1000以內'
            }
            
        },
        deletePolicy: function (cid) {
            if(cid){
                let data = {
                    policySettingCid: cid
                }
                apiBizDeleteLandlordPolicy(data)
                .then( res => {
                    // console.log(res)
                    if(res.data.status == "SUCCESS"){
                        this.alart.success = true
                        this.msg.success = '刪除成功'
                    }else{
                        this.alart.error = true
                        this.msg.success = '刪除失敗'
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    },
    components: {
        AlartMsg,
    }
}
</script>
<style lang="scss"  >
    .biz-new-policy{
        position: relative;
        width: 1094px;
        .biz-new-policy-head{
            display: flex;
            margin-bottom: 40px;
            .title{
                font-size: 20px;
                font-weight: 500;
            }
            .view-default{
                position: absolute;
                right: 30px;
                display: flex;
                align-items: center;
                a{
                    display: flex;
                    align-items: center;
                }
            }
        }
        .biz-new-policy-body{
            overflow-x: hidden;
            &::-webkit-scrollbar {
                display: none;
            }
            .wrap{
                >div{
                    margin-bottom: 20px;
                }
                .item-list.none-borde{
                    border: solid 0px #d5dad8;
                }
                .item-list{
                    position: relative;
                    border: solid 1px #d5dad8;
                    border-radius: 4px;
                    .view{
                        background-color: #ffffff;
                        padding: 0px 0px 0px 20px;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        width: 660px;
                        // min-height: 62px;
                        height: 62px;
                        overflow-x: hidden;
                        line-height: 1.5;
                        .group{
                            position: absolute;
                            display: flex;
                            align-items: center;
                            top: 14px;
                            right: 20px;
                            .edit,
                            .delete{
                                cursor: pointer;
                            }
                            .edit{
                                margin-right: 12px;
                            }
                        }
                    }
                    .view::-webkit-scrollbar {
                        display: none;
                    }
                }
                
                .edit-item{
                    position: relative;
                    .group{
                        position: absolute;
                        display: flex;
                        align-items: center;
                        top: 14px;
                        right: 20px;
                        .save,
                        .delete{
                            cursor: pointer;
                        }
                        .save{
                            width: 76px;
                            height: 36px;
                            border-radius: 4px;
                            background-color: #ff9275;
                            color: #fff;
                            margin-right: 12px;
                        }
                        .save:hover{
                            background-color: #f5a623;
                            color: #fff;
                        }
                    }
                    textarea{
                        padding: 20px 412px 20px 20px;
                        width: 100%;
                        // width: 660px;
                        // min-height: 62px;
                        height: 104px;
                        overflow-x: hidden;
                        line-height: 1.5;
                        resize: vertical;
                    }
                    textarea::-webkit-scrollbar {
                        display: none;
                    }
                }
                .new-item{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border:1px dashed #cacfcd;
                    height: 56px;
                    border-radius: 4px;
                    cursor: pointer;
                    >img{
                        margin-right: 8px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .biz-new-policy{
            .biz-new-policy-body{
                .wrap{
                    .view{
                        padding: 20px 401px 20px 20px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/NewPolicy.vue